import { ReactNode } from 'react'

interface IProps {
  title: string
  children: ReactNode
}
export const ReportingCard = ({ title, children }: IProps) => (
  <div className='bg-surface border border-border rounded-2xl overflow-hidden'>
    <div className='px-[1.25rem] py-[0.75rem] bg-surface-2 border-b border-border'>
      <h4 className='jost-light text-md text-text'>{title}</h4>
    </div>
    <div className='px-[1.25rem] py-[1.5rem]'>{children}</div>
  </div>
)
